import api from './api'

export default {
  getProfile (request = {}) {
    return api.get('/profile', request)
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
  }
}
